'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uploads = require('helpers/uploads');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileSize = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FileSize, _Component);

  function FileSize() {
    (0, _classCallCheck3.default)(this, FileSize);
    return (0, _possibleConstructorReturn3.default)(this, (FileSize.__proto__ || (0, _getPrototypeOf2.default)(FileSize)).apply(this, arguments));
  }

  (0, _createClass3.default)(FileSize, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _uploads.areUnitsEqual)(nextProps.units, this.props.units);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          size = _props.size,
          units = _props.units;


      if (size === null || size < 0) {
        return _react2.default.createElement('span', { className: className });
      }

      var _formatSizeAndUnits = (0, _uploads.formatSizeAndUnits)(size, units),
          formattedSize = _formatSizeAndUnits.formattedSize,
          formattedUnits = _formatSizeAndUnits.formattedUnits;

      return _react2.default.createElement(
        'span',
        { className: className },
        _react2.default.createElement(
          'span',
          null,
          formattedSize
        ),
        _react2.default.createElement('span', null),
        _react2.default.createElement(
          'span',
          null,
          formattedUnits
        )
      );
    }
  }]);
  return FileSize;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.number,
  units: _propTypes2.default.shape({
    byte: _propTypes2.default.string,
    kilobyte: _propTypes2.default.string,
    megabyte: _propTypes2.default.string,
    gigabyte: _propTypes2.default.string,
    terabyte: _propTypes2.default.string
  })
}, _class.defaultProps = {
  units: {
    byte: 'B',
    kilobyte: 'KB',
    megabyte: 'MB',
    gigabyte: 'GB',
    terabyte: 'TB'
  }
}, _temp);
exports.default = FileSize;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FileSize/FileSize.js
// module id = 1991
// module chunks = 1